const tokens = {
  "fontWeights.hairline": {
    "value": "100",
    "variable": "var(--font-weights-hairline)"
  },
  "fontWeights.thin": {
    "value": "200",
    "variable": "var(--font-weights-thin)"
  },
  "fontWeights.light": {
    "value": "300",
    "variable": "var(--font-weights-light)"
  },
  "fontWeights.normal": {
    "value": "400",
    "variable": "var(--font-weights-normal)"
  },
  "fontWeights.medium": {
    "value": "500",
    "variable": "var(--font-weights-medium)"
  },
  "fontWeights.semibold": {
    "value": "600",
    "variable": "var(--font-weights-semibold)"
  },
  "fontWeights.bold": {
    "value": "700",
    "variable": "var(--font-weights-bold)"
  },
  "fontWeights.extrabold": {
    "value": "800",
    "variable": "var(--font-weights-extrabold)"
  },
  "fontWeights.black": {
    "value": "900",
    "variable": "var(--font-weights-black)"
  },
  "lineHeights.3": {
    "value": ".75rem",
    "variable": "var(--line-heights-3)"
  },
  "lineHeights.4": {
    "value": "1rem",
    "variable": "var(--line-heights-4)"
  },
  "lineHeights.5": {
    "value": "1.25rem",
    "variable": "var(--line-heights-5)"
  },
  "lineHeights.6": {
    "value": "1.5rem",
    "variable": "var(--line-heights-6)"
  },
  "lineHeights.7": {
    "value": "1.75rem",
    "variable": "var(--line-heights-7)"
  },
  "lineHeights.8": {
    "value": "2rem",
    "variable": "var(--line-heights-8)"
  },
  "lineHeights.9": {
    "value": "2.25rem",
    "variable": "var(--line-heights-9)"
  },
  "lineHeights.10": {
    "value": "2.5rem",
    "variable": "var(--line-heights-10)"
  },
  "lineHeights.normal": {
    "value": "normal",
    "variable": "var(--line-heights-normal)"
  },
  "lineHeights.none": {
    "value": "1",
    "variable": "var(--line-heights-none)"
  },
  "lineHeights.shorter": {
    "value": "1.25",
    "variable": "var(--line-heights-shorter)"
  },
  "lineHeights.short": {
    "value": "1.375",
    "variable": "var(--line-heights-short)"
  },
  "lineHeights.base": {
    "value": "1.5",
    "variable": "var(--line-heights-base)"
  },
  "lineHeights.tall": {
    "value": "1.625",
    "variable": "var(--line-heights-tall)"
  },
  "lineHeights.taller": {
    "value": "2",
    "variable": "var(--line-heights-taller)"
  },
  "letterSpacings.tighter": {
    "value": "-0.05em",
    "variable": "var(--letter-spacings-tighter)"
  },
  "letterSpacings.tight": {
    "value": "-0.025em",
    "variable": "var(--letter-spacings-tight)"
  },
  "letterSpacings.normal": {
    "value": "0",
    "variable": "var(--letter-spacings-normal)"
  },
  "letterSpacings.wide": {
    "value": "0.025em",
    "variable": "var(--letter-spacings-wide)"
  },
  "letterSpacings.wider": {
    "value": "0.05em",
    "variable": "var(--letter-spacings-wider)"
  },
  "letterSpacings.widest": {
    "value": "0.1em",
    "variable": "var(--letter-spacings-widest)"
  },
  "blurs.none": {
    "value": "0",
    "variable": "var(--blurs-none)"
  },
  "blurs.sm": {
    "value": "4px",
    "variable": "var(--blurs-sm)"
  },
  "blurs.base": {
    "value": "8px",
    "variable": "var(--blurs-base)"
  },
  "blurs.md": {
    "value": "12px",
    "variable": "var(--blurs-md)"
  },
  "blurs.lg": {
    "value": "16px",
    "variable": "var(--blurs-lg)"
  },
  "blurs.xl": {
    "value": "24px",
    "variable": "var(--blurs-xl)"
  },
  "blurs.2xl": {
    "value": "40px",
    "variable": "var(--blurs-2xl)"
  },
  "blurs.3xl": {
    "value": "64px",
    "variable": "var(--blurs-3xl)"
  },
  "borders.none": {
    "value": "0",
    "variable": "var(--borders-none)"
  },
  "borders.1px": {
    "value": "1px solid",
    "variable": "var(--borders-1px)"
  },
  "borders.2px": {
    "value": "2px solid",
    "variable": "var(--borders-2px)"
  },
  "borders.4px": {
    "value": "4px solid",
    "variable": "var(--borders-4px)"
  },
  "borders.8px": {
    "value": "8px solid",
    "variable": "var(--borders-8px)"
  },
  "durations.ultra-fast": {
    "value": "50ms",
    "variable": "var(--durations-ultra-fast)"
  },
  "durations.faster": {
    "value": "100ms",
    "variable": "var(--durations-faster)"
  },
  "durations.fast": {
    "value": "150ms",
    "variable": "var(--durations-fast)"
  },
  "durations.normal": {
    "value": "200ms",
    "variable": "var(--durations-normal)"
  },
  "durations.slow": {
    "value": "300ms",
    "variable": "var(--durations-slow)"
  },
  "durations.slower": {
    "value": "400ms",
    "variable": "var(--durations-slower)"
  },
  "durations.ultra-slow": {
    "value": "500ms",
    "variable": "var(--durations-ultra-slow)"
  },
  "easings.ease-in": {
    "value": "cubic-bezier(0.4, 0, 1, 1)",
    "variable": "var(--easings-ease-in)"
  },
  "easings.ease-out": {
    "value": "cubic-bezier(0, 0, 0.2, 1)",
    "variable": "var(--easings-ease-out)"
  },
  "easings.ease-in-out": {
    "value": "cubic-bezier(0.4, 0, 0.2, 1)",
    "variable": "var(--easings-ease-in-out)"
  },
  "radii.none": {
    "value": "0",
    "variable": "var(--radii-none)"
  },
  "radii.sm": {
    "value": "0.125rem",
    "variable": "var(--radii-sm)"
  },
  "radii.base": {
    "value": "0.25rem",
    "variable": "var(--radii-base)"
  },
  "radii.md": {
    "value": "0.375rem",
    "variable": "var(--radii-md)"
  },
  "radii.lg": {
    "value": "0.5rem",
    "variable": "var(--radii-lg)"
  },
  "radii.xl": {
    "value": "0.75rem",
    "variable": "var(--radii-xl)"
  },
  "radii.2xl": {
    "value": "1rem",
    "variable": "var(--radii-2xl)"
  },
  "radii.3xl": {
    "value": "1.5rem",
    "variable": "var(--radii-3xl)"
  },
  "radii.full": {
    "value": "9999px",
    "variable": "var(--radii-full)"
  },
  "radii.button": {
    "value": "2rem",
    "variable": "var(--radii-button)"
  },
  "shadows.xs": {
    "value": "0 0 0 1px rgba(0, 0, 0, 0.05)",
    "variable": "var(--shadows-xs)"
  },
  "shadows.sm": {
    "value": "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
    "variable": "var(--shadows-sm)"
  },
  "shadows.base": {
    "value": "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
    "variable": "var(--shadows-base)"
  },
  "shadows.md": {
    "value": "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
    "variable": "var(--shadows-md)"
  },
  "shadows.lg": {
    "value": "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    "variable": "var(--shadows-lg)"
  },
  "shadows.xl": {
    "value": "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
    "variable": "var(--shadows-xl)"
  },
  "shadows.2xl": {
    "value": "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
    "variable": "var(--shadows-2xl)"
  },
  "shadows.inner": {
    "value": "inset 0 2px 4px 0 rgba(0,0,0,0.06)",
    "variable": "var(--shadows-inner)"
  },
  "shadows.none": {
    "value": "none",
    "variable": "var(--shadows-none)"
  },
  "shadows.dark-lg": {
    "value": "rgba(0, 0, 0, 0.1) 0px 0px 0px 1px, rgba(0, 0, 0, 0.2) 0px 5px 10px, rgba(0, 0, 0, 0.4) 0px 15px 40px",
    "variable": "var(--shadows-dark-lg)"
  },
  "spacing.1": {
    "value": "0.22rem",
    "variable": "var(--spacing-1)"
  },
  "spacing.2": {
    "value": "0.44rem",
    "variable": "var(--spacing-2)"
  },
  "spacing.3": {
    "value": "0.66rem",
    "variable": "var(--spacing-3)"
  },
  "spacing.4": {
    "value": "0.88rem",
    "variable": "var(--spacing-4)"
  },
  "spacing.5": {
    "value": "1.1rem",
    "variable": "var(--spacing-5)"
  },
  "spacing.6": {
    "value": "1.32rem",
    "variable": "var(--spacing-6)"
  },
  "spacing.7": {
    "value": "1.54rem",
    "variable": "var(--spacing-7)"
  },
  "spacing.8": {
    "value": "1.76rem",
    "variable": "var(--spacing-8)"
  },
  "spacing.9": {
    "value": "1.98rem",
    "variable": "var(--spacing-9)"
  },
  "spacing.10": {
    "value": "2.2rem",
    "variable": "var(--spacing-10)"
  },
  "spacing.12": {
    "value": "2.64rem",
    "variable": "var(--spacing-12)"
  },
  "spacing.14": {
    "value": "3.08rem",
    "variable": "var(--spacing-14)"
  },
  "spacing.16": {
    "value": "3.52rem",
    "variable": "var(--spacing-16)"
  },
  "spacing.20": {
    "value": "4.4rem",
    "variable": "var(--spacing-20)"
  },
  "spacing.24": {
    "value": "5.28rem",
    "variable": "var(--spacing-24)"
  },
  "spacing.28": {
    "value": "6.16rem",
    "variable": "var(--spacing-28)"
  },
  "spacing.32": {
    "value": "7.04rem",
    "variable": "var(--spacing-32)"
  },
  "spacing.36": {
    "value": "7.92rem",
    "variable": "var(--spacing-36)"
  },
  "spacing.40": {
    "value": "8.8rem",
    "variable": "var(--spacing-40)"
  },
  "spacing.44": {
    "value": "9.68rem",
    "variable": "var(--spacing-44)"
  },
  "spacing.48": {
    "value": "10.56rem",
    "variable": "var(--spacing-48)"
  },
  "spacing.52": {
    "value": "11.44rem",
    "variable": "var(--spacing-52)"
  },
  "spacing.56": {
    "value": "12.32rem",
    "variable": "var(--spacing-56)"
  },
  "spacing.60": {
    "value": "13.2rem",
    "variable": "var(--spacing-60)"
  },
  "spacing.64": {
    "value": "14.08rem",
    "variable": "var(--spacing-64)"
  },
  "spacing.72": {
    "value": "15.84rem",
    "variable": "var(--spacing-72)"
  },
  "spacing.80": {
    "value": "17.6rem",
    "variable": "var(--spacing-80)"
  },
  "spacing.96": {
    "value": "21.12rem",
    "variable": "var(--spacing-96)"
  },
  "spacing.px": {
    "value": "1px",
    "variable": "var(--spacing-px)"
  },
  "spacing.0.5": {
    "value": "0.11rem",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.1.5": {
    "value": "0.33rem",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.2.5": {
    "value": "0.55rem",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.3.5": {
    "value": "0.77rem",
    "variable": "var(--spacing-3\\.5)"
  },
  "sizes.1": {
    "value": "0.22rem",
    "variable": "var(--sizes-1)"
  },
  "sizes.2": {
    "value": "0.44rem",
    "variable": "var(--sizes-2)"
  },
  "sizes.3": {
    "value": "0.66rem",
    "variable": "var(--sizes-3)"
  },
  "sizes.4": {
    "value": "0.88rem",
    "variable": "var(--sizes-4)"
  },
  "sizes.5": {
    "value": "1.1rem",
    "variable": "var(--sizes-5)"
  },
  "sizes.6": {
    "value": "1.32rem",
    "variable": "var(--sizes-6)"
  },
  "sizes.7": {
    "value": "1.54rem",
    "variable": "var(--sizes-7)"
  },
  "sizes.8": {
    "value": "1.76rem",
    "variable": "var(--sizes-8)"
  },
  "sizes.9": {
    "value": "1.98rem",
    "variable": "var(--sizes-9)"
  },
  "sizes.10": {
    "value": "2.2rem",
    "variable": "var(--sizes-10)"
  },
  "sizes.12": {
    "value": "2.64rem",
    "variable": "var(--sizes-12)"
  },
  "sizes.14": {
    "value": "3.08rem",
    "variable": "var(--sizes-14)"
  },
  "sizes.16": {
    "value": "3.52rem",
    "variable": "var(--sizes-16)"
  },
  "sizes.20": {
    "value": "4.4rem",
    "variable": "var(--sizes-20)"
  },
  "sizes.24": {
    "value": "5.28rem",
    "variable": "var(--sizes-24)"
  },
  "sizes.28": {
    "value": "6.16rem",
    "variable": "var(--sizes-28)"
  },
  "sizes.32": {
    "value": "7.04rem",
    "variable": "var(--sizes-32)"
  },
  "sizes.36": {
    "value": "7.92rem",
    "variable": "var(--sizes-36)"
  },
  "sizes.40": {
    "value": "8.8rem",
    "variable": "var(--sizes-40)"
  },
  "sizes.44": {
    "value": "9.68rem",
    "variable": "var(--sizes-44)"
  },
  "sizes.48": {
    "value": "10.56rem",
    "variable": "var(--sizes-48)"
  },
  "sizes.52": {
    "value": "11.44rem",
    "variable": "var(--sizes-52)"
  },
  "sizes.56": {
    "value": "12.32rem",
    "variable": "var(--sizes-56)"
  },
  "sizes.60": {
    "value": "13.2rem",
    "variable": "var(--sizes-60)"
  },
  "sizes.64": {
    "value": "14.08rem",
    "variable": "var(--sizes-64)"
  },
  "sizes.72": {
    "value": "15.84rem",
    "variable": "var(--sizes-72)"
  },
  "sizes.80": {
    "value": "17.6rem",
    "variable": "var(--sizes-80)"
  },
  "sizes.96": {
    "value": "21.12rem",
    "variable": "var(--sizes-96)"
  },
  "sizes.max": {
    "value": "max-content",
    "variable": "var(--sizes-max)"
  },
  "sizes.min": {
    "value": "min-content",
    "variable": "var(--sizes-min)"
  },
  "sizes.full": {
    "value": "100%",
    "variable": "var(--sizes-full)"
  },
  "sizes.3xs": {
    "value": "14rem",
    "variable": "var(--sizes-3xs)"
  },
  "sizes.2xs": {
    "value": "16rem",
    "variable": "var(--sizes-2xs)"
  },
  "sizes.xs": {
    "value": "20rem",
    "variable": "var(--sizes-xs)"
  },
  "sizes.sm": {
    "value": "24rem",
    "variable": "var(--sizes-sm)"
  },
  "sizes.md": {
    "value": "28rem",
    "variable": "var(--sizes-md)"
  },
  "sizes.lg": {
    "value": "32rem",
    "variable": "var(--sizes-lg)"
  },
  "sizes.xl": {
    "value": "36rem",
    "variable": "var(--sizes-xl)"
  },
  "sizes.2xl": {
    "value": "42rem",
    "variable": "var(--sizes-2xl)"
  },
  "sizes.3xl": {
    "value": "48rem",
    "variable": "var(--sizes-3xl)"
  },
  "sizes.4xl": {
    "value": "56rem",
    "variable": "var(--sizes-4xl)"
  },
  "sizes.5xl": {
    "value": "64rem",
    "variable": "var(--sizes-5xl)"
  },
  "sizes.6xl": {
    "value": "72rem",
    "variable": "var(--sizes-6xl)"
  },
  "sizes.7xl": {
    "value": "80rem",
    "variable": "var(--sizes-7xl)"
  },
  "sizes.8xl": {
    "value": "90rem",
    "variable": "var(--sizes-8xl)"
  },
  "sizes.prose": {
    "value": "60ch",
    "variable": "var(--sizes-prose)"
  },
  "sizes.container.sm": {
    "value": "640px",
    "variable": "var(--sizes-container-sm)"
  },
  "sizes.container.md": {
    "value": "768px",
    "variable": "var(--sizes-container-md)"
  },
  "sizes.container.lg": {
    "value": "1024px",
    "variable": "var(--sizes-container-lg)"
  },
  "sizes.container.xl": {
    "value": "1280px",
    "variable": "var(--sizes-container-xl)"
  },
  "sizes.px": {
    "value": "1px",
    "variable": "var(--sizes-px)"
  },
  "sizes.0.5": {
    "value": "0.11rem",
    "variable": "var(--sizes-0\\.5)"
  },
  "sizes.1.5": {
    "value": "0.33rem",
    "variable": "var(--sizes-1\\.5)"
  },
  "sizes.2.5": {
    "value": "0.55rem",
    "variable": "var(--sizes-2\\.5)"
  },
  "sizes.3.5": {
    "value": "0.77rem",
    "variable": "var(--sizes-3\\.5)"
  },
  "sizes.breakpoint-sm": {
    "value": "30em",
    "variable": "var(--sizes-breakpoint-sm)"
  },
  "sizes.breakpoint-md": {
    "value": "48em",
    "variable": "var(--sizes-breakpoint-md)"
  },
  "sizes.breakpoint-lg": {
    "value": "62em",
    "variable": "var(--sizes-breakpoint-lg)"
  },
  "sizes.breakpoint-xl": {
    "value": "80em",
    "variable": "var(--sizes-breakpoint-xl)"
  },
  "sizes.breakpoint-2xl": {
    "value": "96em",
    "variable": "var(--sizes-breakpoint-2xl)"
  },
  "fontSizes.3xs": {
    "value": "0.45rem",
    "variable": "var(--font-sizes-3xs)"
  },
  "fontSizes.2xs": {
    "value": "0.625rem",
    "variable": "var(--font-sizes-2xs)"
  },
  "fontSizes.xs": {
    "value": "0.75rem",
    "variable": "var(--font-sizes-xs)"
  },
  "fontSizes.sm": {
    "value": "0.875rem",
    "variable": "var(--font-sizes-sm)"
  },
  "fontSizes.md": {
    "value": "0.9rem",
    "variable": "var(--font-sizes-md)"
  },
  "fontSizes.lg": {
    "value": "1.012rem",
    "variable": "var(--font-sizes-lg)"
  },
  "fontSizes.xl": {
    "value": "1.125rem",
    "variable": "var(--font-sizes-xl)"
  },
  "fontSizes.2xl": {
    "value": "1.35rem",
    "variable": "var(--font-sizes-2xl)"
  },
  "fontSizes.3xl": {
    "value": "1.687rem",
    "variable": "var(--font-sizes-3xl)"
  },
  "fontSizes.4xl": {
    "value": "2.025rem",
    "variable": "var(--font-sizes-4xl)"
  },
  "fontSizes.5xl": {
    "value": "2.7rem",
    "variable": "var(--font-sizes-5xl)"
  },
  "fontSizes.6xl": {
    "value": "3.375rem",
    "variable": "var(--font-sizes-6xl)"
  },
  "fontSizes.7xl": {
    "value": "4.05rem",
    "variable": "var(--font-sizes-7xl)"
  },
  "fontSizes.8xl": {
    "value": "5.4rem",
    "variable": "var(--font-sizes-8xl)"
  },
  "fontSizes.9xl": {
    "value": "7.2rem",
    "variable": "var(--font-sizes-9xl)"
  },
  "zIndex.hide": {
    "value": "-1",
    "variable": "var(--z-index-hide)"
  },
  "zIndex.auto": {
    "value": "auto",
    "variable": "var(--z-index-auto)"
  },
  "zIndex.base": {
    "value": "0",
    "variable": "var(--z-index-base)"
  },
  "zIndex.docked": {
    "value": "10",
    "variable": "var(--z-index-docked)"
  },
  "zIndex.dropdown": {
    "value": "1000",
    "variable": "var(--z-index-dropdown)"
  },
  "zIndex.sticky": {
    "value": "1100",
    "variable": "var(--z-index-sticky)"
  },
  "zIndex.banner": {
    "value": "1200",
    "variable": "var(--z-index-banner)"
  },
  "zIndex.modal": {
    "value": "1400",
    "variable": "var(--z-index-modal)"
  },
  "zIndex.popover": {
    "value": "1500",
    "variable": "var(--z-index-popover)"
  },
  "zIndex.skipLink": {
    "value": "1600",
    "variable": "var(--z-index-skip-link)"
  },
  "zIndex.toast": {
    "value": "1700",
    "variable": "var(--z-index-toast)"
  },
  "zIndex.tooltip": {
    "value": "1800",
    "variable": "var(--z-index-tooltip)"
  },
  "zIndex.code": {
    "value": 1,
    "variable": "var(--z-index-code)"
  },
  "zIndex.breadcrumbContainer": {
    "value": 2,
    "variable": "var(--z-index-breadcrumb-container)"
  },
  "zIndex.projectAreaMenu": {
    "value": 3,
    "variable": "var(--z-index-project-area-menu)"
  },
  "zIndex.codePopUp": {
    "value": 3,
    "variable": "var(--z-index-code-pop-up)"
  },
  "zIndex.sidebarHeader": {
    "value": 3,
    "variable": "var(--z-index-sidebar-header)"
  },
  "zIndex.splitViewDivider": {
    "value": 3,
    "variable": "var(--z-index-split-view-divider)"
  },
  "zIndex.splitViewHideButton": {
    "value": 4,
    "variable": "var(--z-index-split-view-hide-button)"
  },
  "zIndex.aboveTerminal": {
    "value": 20,
    "variable": "var(--z-index-above-terminal)"
  },
  "zIndex.overlay": {
    "value": 30,
    "variable": "var(--z-index-overlay)"
  },
  "zIndex.aboveDialogs": {
    "value": 1500,
    "variable": "var(--z-index-above-dialogs)"
  },
  "fonts.heading": {
    "value": "Helvetica, Arial, sans-serif",
    "variable": "var(--fonts-heading)"
  },
  "fonts.body": {
    "value": "Helvetica, Arial, sans-serif",
    "variable": "var(--fonts-body)"
  },
  "fonts.mono": {
    "value": "SFMono-Regular,Menlo,Monaco,Consolas,\"Liberation Mono\",\"Courier New\",monospace",
    "variable": "var(--fonts-mono)"
  },
  "fonts.display": {
    "value": "Helvetica, Arial, sans-serif",
    "variable": "var(--fonts-display)"
  },
  "fonts.code": {
    "value": "Source Code Pro, monospace",
    "variable": "var(--fonts-code)"
  },
  "colors.transparent": {
    "value": "transparent",
    "variable": "var(--colors-transparent)"
  },
  "colors.current": {
    "value": "currentColor",
    "variable": "var(--colors-current)"
  },
  "colors.black": {
    "value": "#000000",
    "variable": "var(--colors-black)"
  },
  "colors.white": {
    "value": "#FFFFFF",
    "variable": "var(--colors-white)"
  },
  "colors.whiteAlpha.50": {
    "value": "rgba(255, 255, 255, 0.04)",
    "variable": "var(--colors-white-alpha-50)"
  },
  "colors.whiteAlpha.100": {
    "value": "rgba(255, 255, 255, 0.06)",
    "variable": "var(--colors-white-alpha-100)"
  },
  "colors.whiteAlpha.200": {
    "value": "rgba(255, 255, 255, 0.08)",
    "variable": "var(--colors-white-alpha-200)"
  },
  "colors.whiteAlpha.300": {
    "value": "rgba(255, 255, 255, 0.16)",
    "variable": "var(--colors-white-alpha-300)"
  },
  "colors.whiteAlpha.400": {
    "value": "rgba(255, 255, 255, 0.24)",
    "variable": "var(--colors-white-alpha-400)"
  },
  "colors.whiteAlpha.500": {
    "value": "rgba(255, 255, 255, 0.36)",
    "variable": "var(--colors-white-alpha-500)"
  },
  "colors.whiteAlpha.600": {
    "value": "rgba(255, 255, 255, 0.48)",
    "variable": "var(--colors-white-alpha-600)"
  },
  "colors.whiteAlpha.700": {
    "value": "rgba(255, 255, 255, 0.64)",
    "variable": "var(--colors-white-alpha-700)"
  },
  "colors.whiteAlpha.800": {
    "value": "rgba(255, 255, 255, 0.80)",
    "variable": "var(--colors-white-alpha-800)"
  },
  "colors.whiteAlpha.900": {
    "value": "rgba(255, 255, 255, 0.92)",
    "variable": "var(--colors-white-alpha-900)"
  },
  "colors.blackAlpha.50": {
    "value": "rgba(0, 0, 0, 0.04)",
    "variable": "var(--colors-black-alpha-50)"
  },
  "colors.blackAlpha.100": {
    "value": "rgba(0, 0, 0, 0.06)",
    "variable": "var(--colors-black-alpha-100)"
  },
  "colors.blackAlpha.200": {
    "value": "rgba(0, 0, 0, 0.08)",
    "variable": "var(--colors-black-alpha-200)"
  },
  "colors.blackAlpha.300": {
    "value": "rgba(0, 0, 0, 0.16)",
    "variable": "var(--colors-black-alpha-300)"
  },
  "colors.blackAlpha.400": {
    "value": "rgba(0, 0, 0, 0.24)",
    "variable": "var(--colors-black-alpha-400)"
  },
  "colors.blackAlpha.500": {
    "value": "rgba(0, 0, 0, 0.36)",
    "variable": "var(--colors-black-alpha-500)"
  },
  "colors.blackAlpha.600": {
    "value": "rgba(0, 0, 0, 0.48)",
    "variable": "var(--colors-black-alpha-600)"
  },
  "colors.blackAlpha.700": {
    "value": "rgba(0, 0, 0, 0.64)",
    "variable": "var(--colors-black-alpha-700)"
  },
  "colors.blackAlpha.800": {
    "value": "rgba(0, 0, 0, 0.80)",
    "variable": "var(--colors-black-alpha-800)"
  },
  "colors.blackAlpha.900": {
    "value": "rgba(0, 0, 0, 0.92)",
    "variable": "var(--colors-black-alpha-900)"
  },
  "colors.red.50": {
    "value": "#FFF5F5",
    "variable": "var(--colors-red-50)"
  },
  "colors.red.100": {
    "value": "#FED7D7",
    "variable": "var(--colors-red-100)"
  },
  "colors.red.200": {
    "value": "#FEB2B2",
    "variable": "var(--colors-red-200)"
  },
  "colors.red.300": {
    "value": "#FC8181",
    "variable": "var(--colors-red-300)"
  },
  "colors.red.400": {
    "value": "#F56565",
    "variable": "var(--colors-red-400)"
  },
  "colors.red.500": {
    "value": "#E53E3E",
    "variable": "var(--colors-red-500)"
  },
  "colors.red.600": {
    "value": "#C53030",
    "variable": "var(--colors-red-600)"
  },
  "colors.red.700": {
    "value": "#9B2C2C",
    "variable": "var(--colors-red-700)"
  },
  "colors.red.800": {
    "value": "#822727",
    "variable": "var(--colors-red-800)"
  },
  "colors.red.900": {
    "value": "#63171B",
    "variable": "var(--colors-red-900)"
  },
  "colors.orange.50": {
    "value": "#FFFAF0",
    "variable": "var(--colors-orange-50)"
  },
  "colors.orange.100": {
    "value": "#FEEBC8",
    "variable": "var(--colors-orange-100)"
  },
  "colors.orange.200": {
    "value": "#FBD38D",
    "variable": "var(--colors-orange-200)"
  },
  "colors.orange.300": {
    "value": "#F6AD55",
    "variable": "var(--colors-orange-300)"
  },
  "colors.orange.400": {
    "value": "#ED8936",
    "variable": "var(--colors-orange-400)"
  },
  "colors.orange.500": {
    "value": "#DD6B20",
    "variable": "var(--colors-orange-500)"
  },
  "colors.orange.600": {
    "value": "#C05621",
    "variable": "var(--colors-orange-600)"
  },
  "colors.orange.700": {
    "value": "#9C4221",
    "variable": "var(--colors-orange-700)"
  },
  "colors.orange.800": {
    "value": "#7B341E",
    "variable": "var(--colors-orange-800)"
  },
  "colors.orange.900": {
    "value": "#652B19",
    "variable": "var(--colors-orange-900)"
  },
  "colors.yellow.50": {
    "value": "#FFFFF0",
    "variable": "var(--colors-yellow-50)"
  },
  "colors.yellow.100": {
    "value": "#FEFCBF",
    "variable": "var(--colors-yellow-100)"
  },
  "colors.yellow.200": {
    "value": "#FAF089",
    "variable": "var(--colors-yellow-200)"
  },
  "colors.yellow.300": {
    "value": "#F6E05E",
    "variable": "var(--colors-yellow-300)"
  },
  "colors.yellow.400": {
    "value": "#ECC94B",
    "variable": "var(--colors-yellow-400)"
  },
  "colors.yellow.500": {
    "value": "#D69E2E",
    "variable": "var(--colors-yellow-500)"
  },
  "colors.yellow.600": {
    "value": "#B7791F",
    "variable": "var(--colors-yellow-600)"
  },
  "colors.yellow.700": {
    "value": "#975A16",
    "variable": "var(--colors-yellow-700)"
  },
  "colors.yellow.800": {
    "value": "#744210",
    "variable": "var(--colors-yellow-800)"
  },
  "colors.yellow.900": {
    "value": "#5F370E",
    "variable": "var(--colors-yellow-900)"
  },
  "colors.green.50": {
    "value": "#F0FFF4",
    "variable": "var(--colors-green-50)"
  },
  "colors.green.100": {
    "value": "#C6F6D5",
    "variable": "var(--colors-green-100)"
  },
  "colors.green.200": {
    "value": "#9AE6B4",
    "variable": "var(--colors-green-200)"
  },
  "colors.green.300": {
    "value": "#68D391",
    "variable": "var(--colors-green-300)"
  },
  "colors.green.400": {
    "value": "#48BB78",
    "variable": "var(--colors-green-400)"
  },
  "colors.green.500": {
    "value": "#38A169",
    "variable": "var(--colors-green-500)"
  },
  "colors.green.600": {
    "value": "#2F855A",
    "variable": "var(--colors-green-600)"
  },
  "colors.green.700": {
    "value": "#276749",
    "variable": "var(--colors-green-700)"
  },
  "colors.green.800": {
    "value": "#22543D",
    "variable": "var(--colors-green-800)"
  },
  "colors.green.900": {
    "value": "#1C4532",
    "variable": "var(--colors-green-900)"
  },
  "colors.teal.50": {
    "value": "#E6FFFA",
    "variable": "var(--colors-teal-50)"
  },
  "colors.teal.100": {
    "value": "#B2F5EA",
    "variable": "var(--colors-teal-100)"
  },
  "colors.teal.200": {
    "value": "#81E6D9",
    "variable": "var(--colors-teal-200)"
  },
  "colors.teal.300": {
    "value": "#4FD1C5",
    "variable": "var(--colors-teal-300)"
  },
  "colors.teal.400": {
    "value": "#38B2AC",
    "variable": "var(--colors-teal-400)"
  },
  "colors.teal.500": {
    "value": "#319795",
    "variable": "var(--colors-teal-500)"
  },
  "colors.teal.600": {
    "value": "#2C7A7B",
    "variable": "var(--colors-teal-600)"
  },
  "colors.teal.700": {
    "value": "#285E61",
    "variable": "var(--colors-teal-700)"
  },
  "colors.teal.800": {
    "value": "#234E52",
    "variable": "var(--colors-teal-800)"
  },
  "colors.teal.900": {
    "value": "#1D4044",
    "variable": "var(--colors-teal-900)"
  },
  "colors.blue.50": {
    "value": "#ebf8ff",
    "variable": "var(--colors-blue-50)"
  },
  "colors.blue.100": {
    "value": "#bee3f8",
    "variable": "var(--colors-blue-100)"
  },
  "colors.blue.200": {
    "value": "#90cdf4",
    "variable": "var(--colors-blue-200)"
  },
  "colors.blue.300": {
    "value": "#63b3ed",
    "variable": "var(--colors-blue-300)"
  },
  "colors.blue.400": {
    "value": "#4299e1",
    "variable": "var(--colors-blue-400)"
  },
  "colors.blue.500": {
    "value": "#3182ce",
    "variable": "var(--colors-blue-500)"
  },
  "colors.blue.600": {
    "value": "#2b6cb0",
    "variable": "var(--colors-blue-600)"
  },
  "colors.blue.700": {
    "value": "#2c5282",
    "variable": "var(--colors-blue-700)"
  },
  "colors.blue.800": {
    "value": "#2a4365",
    "variable": "var(--colors-blue-800)"
  },
  "colors.blue.900": {
    "value": "#1A365D",
    "variable": "var(--colors-blue-900)"
  },
  "colors.cyan.50": {
    "value": "#EDFDFD",
    "variable": "var(--colors-cyan-50)"
  },
  "colors.cyan.100": {
    "value": "#C4F1F9",
    "variable": "var(--colors-cyan-100)"
  },
  "colors.cyan.200": {
    "value": "#9DECF9",
    "variable": "var(--colors-cyan-200)"
  },
  "colors.cyan.300": {
    "value": "#76E4F7",
    "variable": "var(--colors-cyan-300)"
  },
  "colors.cyan.400": {
    "value": "#0BC5EA",
    "variable": "var(--colors-cyan-400)"
  },
  "colors.cyan.500": {
    "value": "#00B5D8",
    "variable": "var(--colors-cyan-500)"
  },
  "colors.cyan.600": {
    "value": "#00A3C4",
    "variable": "var(--colors-cyan-600)"
  },
  "colors.cyan.700": {
    "value": "#0987A0",
    "variable": "var(--colors-cyan-700)"
  },
  "colors.cyan.800": {
    "value": "#086F83",
    "variable": "var(--colors-cyan-800)"
  },
  "colors.cyan.900": {
    "value": "#065666",
    "variable": "var(--colors-cyan-900)"
  },
  "colors.purple.50": {
    "value": "#FAF5FF",
    "variable": "var(--colors-purple-50)"
  },
  "colors.purple.100": {
    "value": "#E9D8FD",
    "variable": "var(--colors-purple-100)"
  },
  "colors.purple.200": {
    "value": "#D6BCFA",
    "variable": "var(--colors-purple-200)"
  },
  "colors.purple.300": {
    "value": "#B794F4",
    "variable": "var(--colors-purple-300)"
  },
  "colors.purple.400": {
    "value": "#9F7AEA",
    "variable": "var(--colors-purple-400)"
  },
  "colors.purple.500": {
    "value": "#805AD5",
    "variable": "var(--colors-purple-500)"
  },
  "colors.purple.600": {
    "value": "#6B46C1",
    "variable": "var(--colors-purple-600)"
  },
  "colors.purple.700": {
    "value": "#553C9A",
    "variable": "var(--colors-purple-700)"
  },
  "colors.purple.800": {
    "value": "#44337A",
    "variable": "var(--colors-purple-800)"
  },
  "colors.purple.900": {
    "value": "#322659",
    "variable": "var(--colors-purple-900)"
  },
  "colors.pink.50": {
    "value": "#FFF5F7",
    "variable": "var(--colors-pink-50)"
  },
  "colors.pink.100": {
    "value": "#FED7E2",
    "variable": "var(--colors-pink-100)"
  },
  "colors.pink.200": {
    "value": "#FBB6CE",
    "variable": "var(--colors-pink-200)"
  },
  "colors.pink.300": {
    "value": "#F687B3",
    "variable": "var(--colors-pink-300)"
  },
  "colors.pink.400": {
    "value": "#ED64A6",
    "variable": "var(--colors-pink-400)"
  },
  "colors.pink.500": {
    "value": "#D53F8C",
    "variable": "var(--colors-pink-500)"
  },
  "colors.pink.600": {
    "value": "#B83280",
    "variable": "var(--colors-pink-600)"
  },
  "colors.pink.700": {
    "value": "#97266D",
    "variable": "var(--colors-pink-700)"
  },
  "colors.pink.800": {
    "value": "#702459",
    "variable": "var(--colors-pink-800)"
  },
  "colors.pink.900": {
    "value": "#521B41",
    "variable": "var(--colors-pink-900)"
  },
  "colors.brand2.50": {
    "value": "#F7FAFC",
    "variable": "var(--colors-brand2-50)"
  },
  "colors.brand2.100": {
    "value": "#EDF2F7",
    "variable": "var(--colors-brand2-100)"
  },
  "colors.brand2.200": {
    "value": "#E2E8F0",
    "variable": "var(--colors-brand2-200)"
  },
  "colors.brand2.300": {
    "value": "#CBD5E0",
    "variable": "var(--colors-brand2-300)"
  },
  "colors.brand2.400": {
    "value": "#A0AEC0",
    "variable": "var(--colors-brand2-400)"
  },
  "colors.brand2.500": {
    "value": "#718096",
    "variable": "var(--colors-brand2-500)"
  },
  "colors.brand2.600": {
    "value": "#4A5568",
    "variable": "var(--colors-brand2-600)"
  },
  "colors.brand2.700": {
    "value": "#2D3748",
    "variable": "var(--colors-brand2-700)"
  },
  "colors.brand2.800": {
    "value": "#1A202C",
    "variable": "var(--colors-brand2-800)"
  },
  "colors.brand2.900": {
    "value": "#171923",
    "variable": "var(--colors-brand2-900)"
  },
  "colors.brand.50": {
    "value": "#e1dbf3",
    "variable": "var(--colors-brand-50)"
  },
  "colors.brand.100": {
    "value": "#e1dbf3",
    "variable": "var(--colors-brand-100)"
  },
  "colors.brand.200": {
    "value": "#8972cb",
    "variable": "var(--colors-brand-200)"
  },
  "colors.brand.300": {
    "value": "#6f6ac1",
    "variable": "var(--colors-brand-300)"
  },
  "colors.brand.400": {
    "value": "#6e5fc1",
    "variable": "var(--colors-brand-400)"
  },
  "colors.brand.500": {
    "value": "#6c4bc1",
    "variable": "var(--colors-brand-500)"
  },
  "colors.brand.600": {
    "value": "#50388f",
    "variable": "var(--colors-brand-600)"
  },
  "colors.brand.700": {
    "value": "#5c40a6",
    "variable": "var(--colors-brand-700)"
  },
  "colors.brand.800": {
    "value": "#422e75",
    "variable": "var(--colors-brand-800)"
  },
  "colors.brand.900": {
    "value": "#1A365D",
    "variable": "var(--colors-brand-900)"
  },
  "colors.blimpTeal.50": {
    "value": "#e9f6f5",
    "variable": "var(--colors-blimp-teal-50)"
  },
  "colors.blimpTeal.100": {
    "value": "#caebe7",
    "variable": "var(--colors-blimp-teal-100)"
  },
  "colors.blimpTeal.300": {
    "value": "#95d7ce",
    "variable": "var(--colors-blimp-teal-300)"
  },
  "colors.blimpTeal.400": {
    "value": "#7bcdc2",
    "variable": "var(--colors-blimp-teal-400)"
  },
  "colors.blimpTeal.500": {
    "value": "#77c7bc",
    "variable": "var(--colors-blimp-teal-500)"
  },
  "colors.blimpTeal.600": {
    "value": "#4a7b75",
    "variable": "var(--colors-blimp-teal-600)"
  },
  "colors.blimpTeal.700": {
    "value": "#226077",
    "variable": "var(--colors-blimp-teal-700)"
  },
  "colors.gray.10": {
    "value": "#fcfcfc",
    "variable": "var(--colors-gray-10)"
  },
  "colors.gray.50": {
    "value": "#ebebeb",
    "variable": "var(--colors-gray-50)"
  },
  "colors.gray.75": {
    "value": "#f5f6f8",
    "variable": "var(--colors-gray-75)"
  },
  "colors.gray.100": {
    "value": "#e3e3e3",
    "variable": "var(--colors-gray-100)"
  },
  "colors.gray.200": {
    "value": "#d7d8d6",
    "variable": "var(--colors-gray-200)"
  },
  "colors.gray.300": {
    "value": "#cbcccb",
    "variable": "var(--colors-gray-300)"
  },
  "colors.gray.350": {
    "value": "#b4b4b4",
    "variable": "var(--colors-gray-350)"
  },
  "colors.gray.400": {
    "value": "#949494",
    "variable": "var(--colors-gray-400)"
  },
  "colors.gray.500": {
    "value": "#767676",
    "variable": "var(--colors-gray-500)"
  },
  "colors.gray.600": {
    "value": "#575757",
    "variable": "var(--colors-gray-600)"
  },
  "colors.gray.700": {
    "value": "#404040",
    "variable": "var(--colors-gray-700)"
  },
  "colors.gray.800": {
    "value": "#262626",
    "variable": "var(--colors-gray-800)"
  },
  "colors.gray.900": {
    "value": "#1a1a1a",
    "variable": "var(--colors-gray-900)"
  },
  "colors.code.block": {
    "value": "rgba(123, 205, 194, 0.1)",
    "variable": "var(--colors-code-block)"
  },
  "colors.code.blockBorder": {
    "value": "rgb(123, 205, 194)",
    "variable": "var(--colors-code-block-border)"
  },
  "colors.code.blockBackground": {
    "value": "rgba(123, 205, 194, 8%)",
    "variable": "var(--colors-code-block-background)"
  },
  "colors.code.blockBackgroundActive": {
    "value": "rgba(123, 205, 194, 0.17)",
    "variable": "var(--colors-code-block-background-active)"
  },
  "colors.code.blockBorderActive": {
    "value": "rgb(122, 195, 193)",
    "variable": "var(--colors-code-block-border-active)"
  },
  "colors.code.border": {
    "value": "#7bcec3",
    "variable": "var(--colors-code-border)"
  },
  "colors.code.comment": {
    "value": "#6c4bc1",
    "variable": "var(--colors-code-comment)"
  },
  "colors.code.default": {
    "value": "#262626",
    "variable": "var(--colors-code-default)"
  },
  "colors.code.keyword": {
    "value": "#9d4ea9",
    "variable": "var(--colors-code-keyword)"
  },
  "colors.code.literal": {
    "value": "#226077",
    "variable": "var(--colors-code-literal)"
  },
  "colors.code.string": {
    "value": "#ae1f1f",
    "variable": "var(--colors-code-string)"
  },
  "colors.code.activeLine": {
    "value": "#7bcec333",
    "variable": "var(--colors-code-active-line)"
  },
  "colors.code.error": {
    "value": "#cd0365",
    "variable": "var(--colors-code-error)"
  },
  "breakpoints.sm": {
    "value": "30em",
    "variable": "var(--breakpoints-sm)"
  },
  "breakpoints.md": {
    "value": "48em",
    "variable": "var(--breakpoints-md)"
  },
  "breakpoints.lg": {
    "value": "62em",
    "variable": "var(--breakpoints-lg)"
  },
  "breakpoints.xl": {
    "value": "80em",
    "variable": "var(--breakpoints-xl)"
  },
  "breakpoints.2xl": {
    "value": "96em",
    "variable": "var(--breakpoints-2xl)"
  },
  "colors.controlCheckedBg": {
    "value": "var(--colors-brand-500)",
    "variable": "var(--colors-control-checked-bg)"
  },
  "colors.controlCheckedHoverBg": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-control-checked-hover-bg)"
  },
  "colors.focusBorder": {
    "value": "var(--colors-focus-border)",
    "variable": "var(--colors-focus-border)"
  },
  "colors.focusRing": {
    "value": "var(--colors-focus-ring)",
    "variable": "var(--colors-focus-ring)"
  },
  "colors.danger.50": {
    "value": "var(--colors-red-50)",
    "variable": "var(--colors-danger-50)"
  },
  "colors.danger.100": {
    "value": "var(--colors-red-100)",
    "variable": "var(--colors-danger-100)"
  },
  "colors.danger.500": {
    "value": "var(--colors-red-500)",
    "variable": "var(--colors-danger-500)"
  },
  "colors.danger.600": {
    "value": "var(--colors-red-600)",
    "variable": "var(--colors-danger-600)"
  },
  "colors.danger.700": {
    "value": "var(--colors-red-700)",
    "variable": "var(--colors-danger-700)"
  },
  "colors.languageText": {
    "value": "var(--colors-brand-500)",
    "variable": "var(--colors-language-text)"
  },
  "colors.languageTextHover": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-language-text-hover)"
  },
  "colors.headingAccent": {
    "value": "var(--colors-brand-500)",
    "variable": "var(--colors-heading-accent)"
  },
  "colors.button.primaryBg": {
    "value": "var(--colors-brand-500)",
    "variable": "var(--colors-button-primary-bg)"
  },
  "colors.button.primaryHoverBg": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-button-primary-hover-bg)"
  },
  "colors.button.primaryActiveBg": {
    "value": "var(--colors-brand-700)",
    "variable": "var(--colors-button-primary-active-bg)"
  },
  "colors.button.secondaryText": {
    "value": "var(--colors-brand-700)",
    "variable": "var(--colors-button-secondary-text)"
  },
  "colors.button.secondaryBorder": {
    "value": "var(--colors-brand-500)",
    "variable": "var(--colors-button-secondary-border)"
  },
  "colors.button.secondaryHoverBorder": {
    "value": "var(--colors-brand-600)",
    "variable": "var(--colors-button-secondary-hover-border)"
  },
  "colors.button.secondaryHoverBg": {
    "value": "transparent",
    "variable": "var(--colors-button-secondary-hover-bg)"
  },
  "colors.button.secondaryActiveBorder": {
    "value": "var(--colors-brand-700)",
    "variable": "var(--colors-button-secondary-active-border)"
  },
  "colors.button.secondaryActiveBg": {
    "value": "var(--colors-brand-50)",
    "variable": "var(--colors-button-secondary-active-bg)"
  },
  "colors.statusBarBg": {
    "value": "var(--colors-brand2-500)",
    "variable": "var(--colors-status-bar-bg)"
  },
  "colors.sidebarHeaderBg": {
    "value": "var(--colors-brand-500)",
    "variable": "var(--colors-sidebar-header-bg)"
  },
  "colors.sidebarTablistBg": {
    "value": "transparent linear-gradient(to bottom, var(--colors-brand-500) 0%, var(--colors-blimp-teal-400) 100%) 0% 0% no-repeat padding-box",
    "variable": "var(--colors-sidebar-tablist-bg)"
  },
  "colors.sidebarTabSelectedText": {
    "value": "var(--colors-brand-300)",
    "variable": "var(--colors-sidebar-tab-selected-text)"
  },
  "colors.sidebarTabSelectedBg": {
    "value": "var(--colors-gray-75)",
    "variable": "var(--colors-sidebar-tab-selected-bg)"
  },
  "colors.toastSuccessBg": {
    "value": "var(--colors-blimp-teal-700)",
    "variable": "var(--colors-toast-success-bg)"
  },
  "colors.toastInfoBg": {
    "value": "var(--colors-blimp-teal-700)",
    "variable": "var(--colors-toast-info-bg)"
  },
  "colors.toastWarningBg": {
    "value": "var(--colors-code-error)",
    "variable": "var(--colors-toast-warning-bg)"
  },
  "colors.toastErrorBg": {
    "value": "var(--colors-code-error)",
    "variable": "var(--colors-toast-error-bg)"
  },
  "spacing.-1": {
    "value": "calc(var(--spacing-1) * -1)",
    "variable": "var(--spacing-1)"
  },
  "spacing.-2": {
    "value": "calc(var(--spacing-2) * -1)",
    "variable": "var(--spacing-2)"
  },
  "spacing.-3": {
    "value": "calc(var(--spacing-3) * -1)",
    "variable": "var(--spacing-3)"
  },
  "spacing.-4": {
    "value": "calc(var(--spacing-4) * -1)",
    "variable": "var(--spacing-4)"
  },
  "spacing.-5": {
    "value": "calc(var(--spacing-5) * -1)",
    "variable": "var(--spacing-5)"
  },
  "spacing.-6": {
    "value": "calc(var(--spacing-6) * -1)",
    "variable": "var(--spacing-6)"
  },
  "spacing.-7": {
    "value": "calc(var(--spacing-7) * -1)",
    "variable": "var(--spacing-7)"
  },
  "spacing.-8": {
    "value": "calc(var(--spacing-8) * -1)",
    "variable": "var(--spacing-8)"
  },
  "spacing.-9": {
    "value": "calc(var(--spacing-9) * -1)",
    "variable": "var(--spacing-9)"
  },
  "spacing.-10": {
    "value": "calc(var(--spacing-10) * -1)",
    "variable": "var(--spacing-10)"
  },
  "spacing.-12": {
    "value": "calc(var(--spacing-12) * -1)",
    "variable": "var(--spacing-12)"
  },
  "spacing.-14": {
    "value": "calc(var(--spacing-14) * -1)",
    "variable": "var(--spacing-14)"
  },
  "spacing.-16": {
    "value": "calc(var(--spacing-16) * -1)",
    "variable": "var(--spacing-16)"
  },
  "spacing.-20": {
    "value": "calc(var(--spacing-20) * -1)",
    "variable": "var(--spacing-20)"
  },
  "spacing.-24": {
    "value": "calc(var(--spacing-24) * -1)",
    "variable": "var(--spacing-24)"
  },
  "spacing.-28": {
    "value": "calc(var(--spacing-28) * -1)",
    "variable": "var(--spacing-28)"
  },
  "spacing.-32": {
    "value": "calc(var(--spacing-32) * -1)",
    "variable": "var(--spacing-32)"
  },
  "spacing.-36": {
    "value": "calc(var(--spacing-36) * -1)",
    "variable": "var(--spacing-36)"
  },
  "spacing.-40": {
    "value": "calc(var(--spacing-40) * -1)",
    "variable": "var(--spacing-40)"
  },
  "spacing.-44": {
    "value": "calc(var(--spacing-44) * -1)",
    "variable": "var(--spacing-44)"
  },
  "spacing.-48": {
    "value": "calc(var(--spacing-48) * -1)",
    "variable": "var(--spacing-48)"
  },
  "spacing.-52": {
    "value": "calc(var(--spacing-52) * -1)",
    "variable": "var(--spacing-52)"
  },
  "spacing.-56": {
    "value": "calc(var(--spacing-56) * -1)",
    "variable": "var(--spacing-56)"
  },
  "spacing.-60": {
    "value": "calc(var(--spacing-60) * -1)",
    "variable": "var(--spacing-60)"
  },
  "spacing.-64": {
    "value": "calc(var(--spacing-64) * -1)",
    "variable": "var(--spacing-64)"
  },
  "spacing.-72": {
    "value": "calc(var(--spacing-72) * -1)",
    "variable": "var(--spacing-72)"
  },
  "spacing.-80": {
    "value": "calc(var(--spacing-80) * -1)",
    "variable": "var(--spacing-80)"
  },
  "spacing.-96": {
    "value": "calc(var(--spacing-96) * -1)",
    "variable": "var(--spacing-96)"
  },
  "spacing.-px": {
    "value": "calc(var(--spacing-px) * -1)",
    "variable": "var(--spacing-px)"
  },
  "spacing.-0.5": {
    "value": "calc(var(--spacing-0\\.5) * -1)",
    "variable": "var(--spacing-0\\.5)"
  },
  "spacing.-1.5": {
    "value": "calc(var(--spacing-1\\.5) * -1)",
    "variable": "var(--spacing-1\\.5)"
  },
  "spacing.-2.5": {
    "value": "calc(var(--spacing-2\\.5) * -1)",
    "variable": "var(--spacing-2\\.5)"
  },
  "spacing.-3.5": {
    "value": "calc(var(--spacing-3\\.5) * -1)",
    "variable": "var(--spacing-3\\.5)"
  },
  "colors.colorPalette": {
    "value": "var(--colors-color-palette)",
    "variable": "var(--colors-color-palette)"
  },
  "colors.colorPalette.50": {
    "value": "var(--colors-color-palette-50)",
    "variable": "var(--colors-color-palette-50)"
  },
  "colors.colorPalette.100": {
    "value": "var(--colors-color-palette-100)",
    "variable": "var(--colors-color-palette-100)"
  },
  "colors.colorPalette.200": {
    "value": "var(--colors-color-palette-200)",
    "variable": "var(--colors-color-palette-200)"
  },
  "colors.colorPalette.300": {
    "value": "var(--colors-color-palette-300)",
    "variable": "var(--colors-color-palette-300)"
  },
  "colors.colorPalette.400": {
    "value": "var(--colors-color-palette-400)",
    "variable": "var(--colors-color-palette-400)"
  },
  "colors.colorPalette.500": {
    "value": "var(--colors-color-palette-500)",
    "variable": "var(--colors-color-palette-500)"
  },
  "colors.colorPalette.600": {
    "value": "var(--colors-color-palette-600)",
    "variable": "var(--colors-color-palette-600)"
  },
  "colors.colorPalette.700": {
    "value": "var(--colors-color-palette-700)",
    "variable": "var(--colors-color-palette-700)"
  },
  "colors.colorPalette.800": {
    "value": "var(--colors-color-palette-800)",
    "variable": "var(--colors-color-palette-800)"
  },
  "colors.colorPalette.900": {
    "value": "var(--colors-color-palette-900)",
    "variable": "var(--colors-color-palette-900)"
  },
  "colors.colorPalette.10": {
    "value": "var(--colors-color-palette-10)",
    "variable": "var(--colors-color-palette-10)"
  },
  "colors.colorPalette.75": {
    "value": "var(--colors-color-palette-75)",
    "variable": "var(--colors-color-palette-75)"
  },
  "colors.colorPalette.350": {
    "value": "var(--colors-color-palette-350)",
    "variable": "var(--colors-color-palette-350)"
  },
  "colors.colorPalette.block": {
    "value": "var(--colors-color-palette-block)",
    "variable": "var(--colors-color-palette-block)"
  },
  "colors.colorPalette.blockBorder": {
    "value": "var(--colors-color-palette-block-border)",
    "variable": "var(--colors-color-palette-block-border)"
  },
  "colors.colorPalette.blockBackground": {
    "value": "var(--colors-color-palette-block-background)",
    "variable": "var(--colors-color-palette-block-background)"
  },
  "colors.colorPalette.blockBackgroundActive": {
    "value": "var(--colors-color-palette-block-background-active)",
    "variable": "var(--colors-color-palette-block-background-active)"
  },
  "colors.colorPalette.blockBorderActive": {
    "value": "var(--colors-color-palette-block-border-active)",
    "variable": "var(--colors-color-palette-block-border-active)"
  },
  "colors.colorPalette.border": {
    "value": "var(--colors-color-palette-border)",
    "variable": "var(--colors-color-palette-border)"
  },
  "colors.colorPalette.comment": {
    "value": "var(--colors-color-palette-comment)",
    "variable": "var(--colors-color-palette-comment)"
  },
  "colors.colorPalette.default": {
    "value": "var(--colors-color-palette-default)",
    "variable": "var(--colors-color-palette-default)"
  },
  "colors.colorPalette.keyword": {
    "value": "var(--colors-color-palette-keyword)",
    "variable": "var(--colors-color-palette-keyword)"
  },
  "colors.colorPalette.literal": {
    "value": "var(--colors-color-palette-literal)",
    "variable": "var(--colors-color-palette-literal)"
  },
  "colors.colorPalette.string": {
    "value": "var(--colors-color-palette-string)",
    "variable": "var(--colors-color-palette-string)"
  },
  "colors.colorPalette.activeLine": {
    "value": "var(--colors-color-palette-active-line)",
    "variable": "var(--colors-color-palette-active-line)"
  },
  "colors.colorPalette.error": {
    "value": "var(--colors-color-palette-error)",
    "variable": "var(--colors-color-palette-error)"
  },
  "colors.colorPalette.primaryBg": {
    "value": "var(--colors-color-palette-primary-bg)",
    "variable": "var(--colors-color-palette-primary-bg)"
  },
  "colors.colorPalette.primaryHoverBg": {
    "value": "var(--colors-color-palette-primary-hover-bg)",
    "variable": "var(--colors-color-palette-primary-hover-bg)"
  },
  "colors.colorPalette.primaryActiveBg": {
    "value": "var(--colors-color-palette-primary-active-bg)",
    "variable": "var(--colors-color-palette-primary-active-bg)"
  },
  "colors.colorPalette.secondaryText": {
    "value": "var(--colors-color-palette-secondary-text)",
    "variable": "var(--colors-color-palette-secondary-text)"
  },
  "colors.colorPalette.secondaryBorder": {
    "value": "var(--colors-color-palette-secondary-border)",
    "variable": "var(--colors-color-palette-secondary-border)"
  },
  "colors.colorPalette.secondaryHoverBorder": {
    "value": "var(--colors-color-palette-secondary-hover-border)",
    "variable": "var(--colors-color-palette-secondary-hover-border)"
  },
  "colors.colorPalette.secondaryHoverBg": {
    "value": "var(--colors-color-palette-secondary-hover-bg)",
    "variable": "var(--colors-color-palette-secondary-hover-bg)"
  },
  "colors.colorPalette.secondaryActiveBorder": {
    "value": "var(--colors-color-palette-secondary-active-border)",
    "variable": "var(--colors-color-palette-secondary-active-border)"
  },
  "colors.colorPalette.secondaryActiveBg": {
    "value": "var(--colors-color-palette-secondary-active-bg)",
    "variable": "var(--colors-color-palette-secondary-active-bg)"
  }
}

export function token(path, fallback) {
  return tokens[path]?.value || fallback
}

function tokenVar(path, fallback) {
  return tokens[path]?.variable || fallback
}

token.var = tokenVar